
import AccountEmailCheck from "@/components/account/login/AccountEmailCheck.vue";
import AccountLogin from "@/components/account/login/AccountLogin.vue";
import AccountRegistration from "@/components/account/login/AccountRegistration.vue";
import BaseSection from "@/components/base/BaseSection.vue";
import useAccountPages from "@/composables/useAccountPages";
import useRuntimeConfig from "@/composables/useRuntimeConfig";
import { getQueryParamValue } from "@/helpers/urlHelper";
import { Component } from "@/models/enums";
import { computed, defineComponent, ref } from "vue";
import AccountForgotPassword from "./AccountForgotPassword.vue";
import AccountResetPassword from "./AccountResetPassword.vue";

export default defineComponent({
	components: {
		BaseSection,
		AccountLogin,
		AccountRegistration,
		AccountEmailCheck,
		AccountForgotPassword,
		AccountResetPassword,
	},
	props: {
		enableCreate: {
			type: Boolean,
			required: false,
			default: true,
		},
		isAgent: {
			type: Boolean,
			default: false,
		},
		isAccommodation: {
			type: Boolean,
			required: false,
			default: false
		}
	},
	setup(props) {
		const { activeComponent, setComponent } = useAccountPages();
		const { getRuntimeConfig } = useRuntimeConfig();
		const agentLink = ref("");

		getRuntimeConfig().then((x) => (agentLink.value = x.agentAccountUrl));

		const id = getQueryParamValue("id");

		if (id) {
			setComponent(Component[Component.AccountResetPassword]);
		}

		const component = computed(() => {
			if (activeComponent.value) {
				return activeComponent.value;
			}

			if (props.enableCreate) {
				return Component[Component.AccountEmailCheck];
			}

			return Component[Component.AccountLogin];
		});

		return { component, agentLink };
	},
});
